import { __assign, __read } from "tslib";
import { PageviewMonitor } from '../../monitors/pageview';
import { applyMonitor } from '../../utils';
import { getPluginConfig } from './utils';
export var PAGEVIEW_MONITOR_PLUGIN_NAME = 'pageview';
var defaultConfig = {
    sendInit: true,
    routeMode: 'history',
};
export function PageviewMonitorPlugin(client) {
    client.on('init', function () {
        var _a;
        var config = getPluginConfig(client, PAGEVIEW_MONITOR_PLUGIN_NAME, defaultConfig);
        if (!config) {
            return;
        }
        var _b = __read(applyMonitor(PageviewMonitor, __assign(__assign({}, config), { initPid: (_a = client.config()) === null || _a === void 0 ? void 0 : _a.pid, onPidUpdate: function (pid) {
                client.set({ pid: pid, viewId: pid + "_" + Date.now(), actionId: undefined });
            } }), client.report.bind(client)), 2), sendPageview = _b[0], tearDown = _b[1];
        client.on('config', function () {
            sendPageview(client.config().pid);
        });
        client.on('beforeDestroy', tearDown);
        client.provide('sendPageview', sendPageview);
    });
}
//# sourceMappingURL=pageview.js.map